export default __webpack_public_path__ + "static/media/disloyalty-to-the-us.f380ecd6.svg";